export default {"src":"/_next/static/media/check.cdba739a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};